<script setup lang="ts">
  const emit = defineEmits<{
    (event: "onSubmit", val: string): void;
  }>();

  const modal = ref(false);
  const name = ref<string>("");
  const isFormValid = ref(false);

  const openModal = (val: string = "") => {
    name.value = val;
    modal.value = true;
  };

  const handleSend = () => {
    if (!isFormValid.value) {
      return;
    }
    emit("onSubmit", name.value);
    modal.value = false;
  };

  defineExpose({
    openModal,
  });

  // レスポンシブ対応
  const isSp = isSpDisplayRef();
</script>

<template>
  <v-dialog v-model="modal" :max-width="450" scrim="black" opacity="0.9">
    <v-card
      class="d-flex flex-column justify-center dialog-body"
      :class="[isSp ? 'pa-4' : 'px-4 py-8']"
      data-testid="step-delivery-create-dialog"
    >
      <div class="text-h6 font-weight-bold text-center mb-4">ステップ配信タイトル</div>
      <v-form v-model="isFormValid" @submit.prevent="handleSend">
        <AtomsItemHeading note="全角100文字まで">ステップ名 <span class="text-red">※必須</span></AtomsItemHeading>
        <AtomsInputText
          v-model:text="name"
          label=""
          bg-color="white"
          :rules="stepDeliveryNameRules"
          :maxlength="100"
          placeholder="ステップ配信タイトルをつけてしてください"
        />

        <div class="d-flex ga-4 mt-4">
          <AtomsButton variant="outlined" size="x-large" color="white" @click="modal = false"> キャンセル </AtomsButton>
          <AtomsButton type="submit" :disabled="!name || !isFormValid" color="blue" size="x-large">
            作成する
          </AtomsButton>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
  @import "assets/media.scss";
  .dialog-body {
    height: 100%;
    color: white;
    background-color: rgba(var(--v-theme-monochrome-04), 0.85);
  }
</style>
